import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { combineReducers } from 'redux';

import MessagesStore from '../../stores/messagesStore';

import globalError from 'webapp-common-ui/src/reducers/globalErrorReducer';
import user from 'webapp-common-ui/src/reducers/userReducer';
import ticketListings from './ticketListingsReducer';
import analytics from './analytics';

import globalModal from 'webapp-common-ui/src/reducers/globalModalReducer';
import pricing from '../../reducers/pricingReducer';
import priceHelp from '../../reducers/priceHelpReducer';
import payment from '../../reducers/paymentReducer';
import { PAGE_OPTIONS } from '../constants';
import mapGeometry from '../../reducers/mapGeometryReducer';
import currentlyListed from '../../reducers/currListedReducer';
import sectionAvailability from '../../reducers/sectionAvailabilityReducer';
import siteContext from '../../reducers/siteContextReducer';
import deepLink from './deepLink';

const options = {
  siteContext: window.siteContext,
  pageContext: window.pageContext,
  ...PAGE_OPTIONS,
};

export default combineReducers({
  messages: (state = MessagesStore.get()) => state,
  options: (state = options) => state,
  globalError,
  ticketListings,
  user,
  globalModal,
  pricing,
  payment,
  analytics,
  priceHelp,
  mapGeometry,
  currentlyListed,
  sectionAvailability,
  siteContext,
  deepLink,
});

export const getSiteRoot = store => get(store, 'options.siteContext.siteRoot', '');

export const getBrand = (store) => {
  const brand = get(store, 'options.siteContext.brand');

  if (isEmpty(brand)) {
    return undefined;
  }

  return brand;
};
